import App from './App.svelte';
import 'notyf/notyf.min.css';

const app = new App({
	target: document.body
});

export default app;